var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2148 18.9391L17.2148 22.9391L9.21484 19.9391V22.9391L5.02484 17.1891L17.9348 18.2391V7.27909L22.2148 6.58909V18.9391ZM5.02484 17.1891V9.89909L17.9348 7.27909L10.8148 2.93909V5.77909L4.18484 7.69909L2.21484 10.3191V16.0091L5.02484 17.1891Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops);
export default __webpack_public_path__ + "static/media/devops.e693befc.svg";
export { ForwardRef as ReactComponent };